import styled from 'styled-components';

const MobileMenuStyle = styled.div`
	--mobileMenuContPaddingV: var(--sp3x);
	--mobileMenuContPaddingH: var(--sp8x);

	position: fixed;
	top: ${({ topPosition }) => `${topPosition}px`};
    top: var(--headerFixHeight);
	bottom: 0;
	left: 0;
	right: 0;
	overflow: hidden;
	pointer-events: none;
	z-index: 10;

	.menu-cont {
		width: 100%;
		height: 100%;
		padding: var(--mobileMenuContPaddingV) var(--mobileMenuContPaddingH) calc(var(--mobileMenuContPaddingV) * 3);
		opacity: 0;
		transform: translateY(100%);
		transition: all var(--trTime);
		overflow-y: scroll;
		-ms-overflow-style: none;
		scrollbar-width: none;
		z-index: 10000;

		&::-webkit-scrollbar {
			display: none;
		}
	}

	&.opened {
		pointer-events: all;
		.menu-cont {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.links-wrap {
		display: flex;
		flex-direction: column;
		margin-left: var(--sp3x);
		margin-top: var(--sp3x);

		.blog {
			margin-top: var(--sp3x);
		}

		.link-item {
			width: fit-content;
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--mobileMenuContPaddingH: var(--sp4x);

		.links-wrap {
			display: flex;
			flex-direction: column;
			margin-left: var(--sp2x);

			.link-item {
				width: fit-content;
			}
		}
	}
`

export default MobileMenuStyle;
